import {
  PATIENTS_BYUSER_GET_LIST,
  PATIENTS_BYUSER_GET_LIST_SUCCESS,
  PATIENTS_BYUSER_GET_LIST_ERROR,
  PATIENTS_BYDOCTOR_GET_LIST,
  PATIENTS_BYDOCTOR_GET_LIST_ERROR,
  PATIENTS_BYDOCTOR_GET_LIST_SUCCESS,
  PATIENT_GET_INFO,
  PATIENT_GET_INFO_SUCCESS,
  PATIENT_GET_INFO_ERROR,
  PATIENT_ADD_ITEM,
  PATIENT_ADD_ITEM_SUCCESS,
  PATIENT_ADD_ITEM_ERROR,
  PATIENT_EDIT_ITEM,
  PATIENT_EDIT_ITEM_SUCCESS,
  PATIENT_EDIT_ITEM_ERROR,
  PATIENT_REMOVE_ITEM,
  PATIENT_REMOVE_ITEM_SUCCESS,
  PATIENT_REMOVE_ITEM_ERROR,
  PATIENTS_CLEAR_DATA,
  PATIENT_CLEAR_DATA,
  PATIENT_CLEAR_MESSAGES,
} from "../actions";

const INIT_STATE = {
  loading: false,
  listByUser: null,
  listByDoctor: null,
  data: null,
  addItem: null,
  editItem: null,
  removeItem: null,
  error: null,
  storedErrors: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    //* GET LIST OF THE PATIENTS PER USER //--------------------------------------------------------
    case PATIENTS_BYUSER_GET_LIST:
      return { ...state, loading: true, error: null };

    case PATIENTS_BYUSER_GET_LIST_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        listByUser: action.payload,
        error: null,
      };

    case PATIENTS_BYUSER_GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* GET LIST OF THE PATIENTS PER DOCTOR //--------------------------------------------------------
    case PATIENTS_BYDOCTOR_GET_LIST:
      return { ...state, loading: true, error: null };

    case PATIENTS_BYDOCTOR_GET_LIST_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        listByDoctor: action.payload,
        error: null,
      };

    case PATIENTS_BYDOCTOR_GET_LIST_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* GET INFO OF THE PATIENT  //----------------------------------------------------------
    case PATIENT_GET_INFO:
      return { ...state, loading: true, error: null };

    case PATIENT_GET_INFO_SUCCESS:
      //console.log(action.payload);
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case PATIENT_GET_INFO_ERROR:
      return { ...state, loading: false, error: action.payload };

    //* ADD PATIENT // ----------------------------------------------------------------------------------------------
    case PATIENT_ADD_ITEM:
      return { ...state, loading: true, error: null };

    case PATIENT_ADD_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loading: false,
        addItem: action.payload,
        error: null,
      };

    case PATIENT_ADD_ITEM_ERROR:
      console.log(action.payload);
      return {
        ...state,
        loading: false,
        addItem: null,
        error: Array.isArray(action.payload)
          ? action.payload.error
          : action.payload,
        storedErrors: [...state.storedErrors, action.payload],
      };

    //* EDIT PATIENT // ---------------------------------------------------------------------------------------------
    case PATIENT_EDIT_ITEM:
      return { ...state, loading: true, error: null };

    case PATIENT_EDIT_ITEM_SUCCESS:
      //console.log("success", action.payload);
      return {
        ...state,
        loading: false,
        editItem: action.payload,
        error: null,
      };

    case PATIENT_EDIT_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        editItem: null,
        error: action.payload,
      };

    //* REMOVE PATIENT // ---------------------------------------------------------------------------------------------
    case PATIENT_REMOVE_ITEM:
      return { ...state, loading: true, error: null };

    case PATIENT_REMOVE_ITEM_SUCCESS:
      console.log("PATIENT_REMOVE_ITEM_SUCCESS", action.payload);
      return {
        ...state,
        loading: false,
        removeItem: action.payload,
        error: null,
      };

    case PATIENT_REMOVE_ITEM_ERROR:
      return {
        ...state,
        loading: false,
        removeItem: null,
        error: action.payload,
      };

    //* CLEAR PATIENTS DATA // ---------------------------------------------------------------------------------------------

    case PATIENTS_CLEAR_DATA:
      return {
        ...state, // repeat all the state and apply the following changes
        loading: false,
        listByUser: null,
        error: null,
      };

    //* CLEAR PATIENT DATA // ---------------------------------------------------------------------------------------------
    // all reducers expept listByUser (this is the listByUser of all patients of the doctor)
    case PATIENT_CLEAR_DATA:
      console.log("PATIENT_CLEAR_DATA", PATIENT_CLEAR_DATA);
      return {
        ...state, // repeat all the state and apply the following changes
        loading: false,

        data: null,
        addItem: null,
        editItem: null,
        removeItem: null,
      };

    //* CLEAR MESSAGES // ---------------------------------------------------------------------------------------------

    case PATIENT_CLEAR_MESSAGES:
      return {
        ...state, // repeat all the state and apply the following changes

        addItem: null,
        editItem: null,
        removeItem: null,
        error: null,
        storedErrors: [],
      };

    default:
      return { ...state };
  }
};
